import React, { useEffect, useState } from 'react';
import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    Radio,
    RadioGroup,
    Typography,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import FieldTextAreaAutoSize from '../fields/fieldTextAreaAutoSize';
import { LabelAnswer } from './labelAnswer';

type Props = {
    title?: string;
    name: any;
    answerQuestion?: any;
    onChange: (value: any) => void;
    idQuestion?: string;
    required?: boolean;
    questionType?: string;
    questionIcon?: string;
    whyQuestion?: boolean;
    dominantColor?: string;
};

const FieldLinealLabelAnswer = ({
    title,
    name,
    answerQuestion,
    onChange,
    idQuestion,
    required = true,
    questionType,
    whyQuestion,
    dominantColor,
}: Props) => {
    const [value, setValue] = React.useState('');
    const [error, setError] = React.useState(false);
    const [helperText, setHelperText] = React.useState('');
    const [why, setWhy] = useState('');
    const [touched, setTouched] = useState(false);

    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue((event.target as HTMLInputElement).value);
        setHelperText(' ');
        setError(false);
        setTouched(true);
    };

    useEffect(() => {
        const isEmpty = value.length === 0;

        if (isEmpty && touched && required) {
            setHelperText('La respuesta es obligatoria');
            setError(true);
        } else {
            setError(false);
        }

        onChange({
            idQuestion,
            [name]: value,
            type: questionType,
            why: why,
            error: required && isEmpty,
        });
    }, [value, touched, why, required]);

    return (
        <>
            <Grid item xs={12} key={idQuestion}>
                <LabelAnswer
                    text={title}
                    isRequired={required}
                    dominantColor={dominantColor}
                />
                <br />
                <FormControl error={error} fullWidth>
                    <Grid
                        display="flex"
                        justifyContent="center"
                        overflow="hidden"
                    >
                        <RadioGroup
                            row
                            onChange={handleRadioChange}
                            sx={{
                                border: error
                                    ? '1px solid #d32f2f'
                                    : '1px solid #E0E0E0',
                                borderRadius: '4px',
                                width: '80%',
                                '.MuiFormHelperText-root': {
                                    textAlign: 'center',
                                },
                            }}
                        >
                            <Grid
                                minWidth="100%"
                                display="inline-block"
                                overflow="overlay"
                            >
                                <Grid display="flex">
                                    {answerQuestion.map((answer: any) => (
                                        <Grid
                                            key={answer.id}
                                            color={dominantColor}
                                            display="block"
                                            style={{
                                                width: `${
                                                    100 /
                                                    (answerQuestion.length || 1)
                                                }%`,
                                                minWidth: '50px',
                                            }}
                                        >
                                            <FormControlLabel
                                                value={answer.id}
                                                control={
                                                    <Radio
                                                        sx={{
                                                            color:
                                                                dominantColor ||
                                                                '#36c',
                                                            '&.Mui-checked': {
                                                                color:
                                                                    dominantColor ||
                                                                    '#36c',
                                                            },
                                                        }}
                                                    />
                                                }
                                                label={answer.label}
                                                labelPlacement="top"
                                                sx={{
                                                    backgroundColor:
                                                        '#D1E2FF8C',
                                                    margin: 0,
                                                    padding: 0,
                                                    justifyContent: 'center',
                                                    width: '100%',
                                                }}
                                            />
                                            <Typography
                                                fontFamily="Lucida Sans"
                                                fontSize="14px"
                                                textAlign="center"
                                                sx={{
                                                    color:
                                                        dominantColor || '#36c',
                                                }}
                                            >
                                                {answer.description}
                                            </Typography>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                        </RadioGroup>
                    </Grid>
                    <FormHelperText sx={{ textAlign: 'center' }}>
                        {helperText}
                    </FormHelperText>
                </FormControl>
            </Grid>
            {whyQuestion && value && (
                <Grid item xs={12}>
                    <LabelAnswer
                        text="¿Por qué?"
                        isRequired={false}
                        dominantColor={dominantColor}
                    />
                    <br />
                    <FieldTextAreaAutoSize
                        name="why"
                        placeholder="Dejanos aquí las razones de porque"
                        required={false}
                        onChange={(e: any) => setWhy(e.target.value)}
                        dominantColor={dominantColor}
                    />
                </Grid>
            )}
        </>
    );
};

export default FieldLinealLabelAnswer;
